import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Outlet, useLocation } from "react-router-dom";

import { Box } from "@chakra-ui/react";

const stripePromise = loadStripe(
  process.env.REACT_APP_ENV === "production"
    ? "pk_live_Gq5azMUpxnzAiRUEzk7lQsCz000crfRftf"
    : "pk_test_6NQsDFKMnhHwvdBlvDCnJnio00qH3BKYRK"
);

const defaultValues = {
  email: "",
  name: "",
  cpf: "",
  city: "",
  country: "BR",
  line1: "",
  line2: "",
  state: "",
  zip: "",
  isBrazilResident: true,
};

export default function CheckoutWrapper() {
  const { pathname } = useLocation();
  const [form, setForm] = useState(defaultValues);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Elements stripe={stripePromise}>
      <Box minHeight="100vh" background="vbaby.canvas">
        <Outlet context={{ form, setForm }} />
      </Box>
    </Elements>
  );
}
